/**
 * STEP -> Main step in the flow
 * SUB_STEP -> Sub step in the flow
 * HYBRID -> A step can be both Main and Sub step
 */
export const STEP_TYPES = {
	step: 'STEP',
	subStep: 'SUB_STEP',
	hybrid: 'HYBRID'
};

export const FLOW_DIRECTION = {
	forward: 'NEXT',
	backward: 'BACK'
};

export const FLOW_TYPE = {
	SGA: 'SGA',
	DGA: 'DGA'
};

export const FLOW_MODE = 'one-button-flow';
